import { render, staticRenderFns } from "./SemenCollectionNew.vue?vue&type=template&id=2e6b6d7e&scoped=true&"
import script from "./SemenCollectionNew.vue?vue&type=script&lang=js&"
export * from "./SemenCollectionNew.vue?vue&type=script&lang=js&"
import style0 from "./SemenCollectionNew.vue?vue&type=style&index=0&id=2e6b6d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b6d7e",
  null
  
)

export default component.exports